import { FieldArray, FormikProps } from 'formik';

import { Col, Label, Input, FormGroup, Row, Button } from 'reactstrap';

import { useSelector } from 'react-redux';
import Cleave from 'cleave.js/react';
import { useTranslation } from 'react-i18next';
import { RootState } from 'slices';

import {
  PromoDiscountForm,
  PromoFormValues,
} from 'types/promotion/promotionTypes';
import {
  handleChangeNumberInput,
  handleChangePercentageInput,
  handleOnKeyUpNumberInput,
  handleOnKeyUpPercentageInput,
} from '../FormHandlers';

import { DiscountTypesOptions } from 'pages/Promotions/PromoConstant';
import { useEffect, useMemo, useRef, useState } from 'react';
import { PROMOTION_DISCOUNT_LIMIT } from '../../PromoConstant';
import styles from 'pages/Promotions/styles/promo.module.css';
import { promoConditionTitle } from './promoConditionTitle';
import { formatNumberWithCommasAnd2Decimals } from 'utils/maths/InputFormats';
import { RiDeleteBin2Line } from 'react-icons/ri';

const PromoReachPurchase = ({
  formik,
}: {
  formik: FormikProps<PromoFormValues>;
}) => {
  const { t } = useTranslation();
  const qtyRefs = useRef<Array<HTMLInputElement | null>>([]);
  const discountRefs = useRef<Array<HTMLInputElement | null>>([]);

  const promotionsState = useSelector((state: RootState) => state.Promotions);

  const { showAllValidateErrors } = promotionsState;

  const [DiscountSign, setDiscountSign] = useState('$');
  useEffect(() => {
    if (formik.values.DiscountType === '2') {
      setDiscountSign('%');
    } else {
      setDiscountSign('฿');
    }
  }, [formik.values?.DiscountType, setDiscountSign]);

  const promoType = useMemo(
    () => formik.values?.promoType || '2',
    [formik.values.promoType]
  );

  const promoConditionsTitle = promoConditionTitle(t).find(
    (promo) => promo.promoType === promoType
  );

  if (!promoConditionsTitle) {
    return null;
  }

  return (
    <>
      <div className={`mb-3 row ${promoType === '3' ? 'd-none' : ''}`}>
        <Label
          htmlFor="DiscountType"
          className="col-sm-3 col-form-label"
        ></Label>
        <Col sm={9}>
          <div className="mt-2">
            <FormGroup key={8}>
              {DiscountTypesOptions(t).map(
                (p: { label: string; value: string }, _index) => (
                  <div key={p.value} className="form-check form-check-inline">
                    <Input
                      className="form-check-input"
                      type="radio"
                      name="DiscountType"
                      id={p.label}
                      value={p.value}
                      checked={formik.values.DiscountType === p.value}
                      onChange={(e) => {
                        formik.handleChange(e);
                        formik
                          .setFieldValue('promoDiscount', [
                            {
                              qty: '',
                              discount: '',
                            },
                          ])
                          .then(() => {
                            formik.setFieldTouched('promoDiscount', true);
                          });
                        if (p.value === '2') {
                          formik.setFieldValue('usage_limit', '0').then(() => {
                            formik.setFieldTouched('usage_limit', true);
                          });
                        }
                      }}
                    />
                    <Label className="form-check-label" htmlFor={p.label}>
                      {p.label}
                    </Label>
                  </div>
                )
              )}
            </FormGroup>
          </div>
        </Col>
      </div>

      <FieldArray
        name="promoDiscount"
        render={(arrayHelpers) => {
          return (
            <Row className="mt-2">
              <Label
                htmlFor="promoDiscount"
                className="col-sm-3 col-form-label"
              ></Label>
              <Col xs={12} sm={9} lg={9} className="mb-2 mb-xs-0 px-0">
                <Row className="align-items-center mb-0 mb-xs-0 justify-content-space-between">
                  <Col xs={5} sm={5} className="mb-0 mb-xs-0">
                    <Label className={`${styles['text-pd']} px-1`}>
                      {promoConditionsTitle.qty}
                    </Label>
                  </Col>
                  <Col xs={5} sm={5} className="mb-0 mb-xs-0 px-0">
                    <Label className={`px-1`}>
                      {promoConditionsTitle.discount}
                    </Label>
                  </Col>
                </Row>
                {formik.values.promoDiscount.map(
                  (promoDiscount: PromoDiscountForm, index: number) => (
                    <Row
                      key={index}
                      className="align-items-top mb-3 mb-xs-0 px-0 mx-0"
                    >
                      <Col xs={5} sm={5} className="mb-2 mb-xs-0 px-0">
                        <div className="input-container px-1">
                          {promoType === '2' ? (
                            <div className="input-group">
                              <span
                                role="button"
                                onClick={() => qtyRefs.current[index]?.focus()}
                                className="input-group-text text-primary"
                                id="promo-price-addon"
                              >
                                ฿
                              </span>
                              {/* <Input
                                innerRef={(el) =>
                                  (qtyRefs.current[index] =
                                    el as HTMLInputElement | null)
                                }
                                type="text"
                                name={`promoDiscount[${index}].qty`}
                                value={formatNumberWithCommasAnd2Decimals(
                                  formik.values.promoDiscount[index].qty
                                )}
                                onChange={(e) => {
                                  handleChangeNumberInput(e, formik);
                                }}
                                onKeyUp={(e) => {
                                  handleOnKeyUpNumberInput(e, formik);
                                }}
                                onBlur={formik.handleBlur}
                                className={`form-control promoDiscount`}
                              /> */}

                              <Cleave
                                htmlRef={(el: HTMLInputElement) =>
                                  (qtyRefs.current[index] = el)
                                }
                                className={`form-control promoDiscount`}
                                // className={`form-control ${styles['no-px']}`}
                                name={`promoDiscount[${index}].qty`}
                                options={{
                                  numeral: true,
                                  numeralDecimalScale: 2,
                                  numeralIntegerScale: 15,
                                  numeralThousandsGroupStyle: 'thousand',
                                }}
                                value={formik.values.promoDiscount[index].qty}
                                onChange={(e: any) => {
                                  formik.setFieldValue(
                                    `promoDiscount[${index}].qty`,
                                    e.target.rawValue
                                  );
                                }}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          ) : (
                            // <Input
                            //   type="text"
                            //   name={`promoDiscount[${index}].qty`}
                            //   value={formatNumberWithCommasAnd2Decimals(
                            //     formik.values.promoDiscount[index].qty
                            //   )}
                            //   onChange={(e) => {
                            //     handleChangeNumberInput(e, formik);
                            //   }}
                            //   onKeyUp={(e) => {
                            //     handleOnKeyUpNumberInput(e, formik);
                            //   }}
                            //   onBlur={formik.handleBlur}
                            //   className={`form-control promoDiscount`}
                            // />
                            <Cleave
                              htmlRef={(el: HTMLInputElement) =>
                                (qtyRefs.current[index] = el)
                              }
                              className={`form-control promoDiscount`}
                              // className={`form-control ${styles['no-px']}`}
                              name={`promoDiscount[${index}].qty`}
                              options={{
                                numeral: true,
                                numeralDecimalScale: 2,
                                numeralIntegerScale: 15,
                                numeralThousandsGroupStyle: 'thousand',
                              }}
                              value={formik.values.promoDiscount[index].qty}
                              onChange={(e: any) => {
                                formik.setFieldValue(
                                  `promoDiscount[${index}].qty`,
                                  e.target.rawValue
                                );
                              }}
                              onBlur={formik.handleBlur}
                            />
                          )}

                          {(formik.touched.promoDiscount &&
                            Array.isArray(formik.touched.promoDiscount) &&
                            formik.touched.promoDiscount[index]?.qty &&
                            formik.errors.promoDiscount &&
                            Array.isArray(formik.errors.promoDiscount) &&
                            typeof formik.errors.promoDiscount[index] ===
                              'object' &&
                            formik.errors.promoDiscount[index] !== null &&
                            'qty' in formik.errors.promoDiscount[index] &&
                            typeof formik.errors.promoDiscount[index].qty ===
                              'string') ||
                          (!formik.isValid &&
                            formik.errors.promoDiscount &&
                            Array.isArray(formik.errors.promoDiscount) &&
                            typeof formik.errors.promoDiscount[index] ===
                              'object' &&
                            formik.errors.promoDiscount[index] !== null &&
                            'qty' in formik.errors.promoDiscount[index] &&
                            typeof formik.errors.promoDiscount[index].qty ===
                              'string' &&
                            showAllValidateErrors) ? (
                            <div className="text-danger">
                              {formik.errors.promoDiscount[index].qty}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                      <Col xs={5} sm={5} className="mb-2 mb-xs-0 px-0">
                        <div className="input-container px-1">
                          <div className="input-group">
                            <span
                              role="button"
                              onClick={() =>
                                discountRefs.current[index]?.focus()
                              }
                              className="input-group-text text-primary"
                              id="promo-price-addon"
                            >
                              {DiscountSign}
                            </span>
                            <Input
                              innerRef={(el) =>
                                (discountRefs.current[index] =
                                  el as HTMLInputElement | null)
                              }
                              type="text"
                              name={`promoDiscount[${index}].discount`}
                              value={formatNumberWithCommasAnd2Decimals(
                                formik.values.promoDiscount[index].discount
                              )}
                              onChange={(e) => {
                                if (formik.values.DiscountType === '2') {
                                  handleChangePercentageInput(e, formik);
                                } else {
                                  handleChangeNumberInput(e, formik);
                                }
                              }}
                              onKeyUp={(e) => {
                                if (formik.values.DiscountType === '2') {
                                  handleOnKeyUpPercentageInput(e, formik);
                                } else {
                                  handleOnKeyUpNumberInput(e, formik);
                                }
                              }}
                              onBlur={formik.handleBlur}
                              className={`form-control ${styles['no-px']}`}
                              maxLength={15}
                            />
                          </div>

                          {(formik.touched.promoDiscount &&
                            Array.isArray(formik.touched.promoDiscount) &&
                            formik.touched.promoDiscount[index]?.discount &&
                            formik.errors.promoDiscount &&
                            Array.isArray(formik.errors.promoDiscount) &&
                            typeof formik.errors.promoDiscount[index] ===
                              'object' &&
                            formik.errors.promoDiscount[index] !== null &&
                            'discount' in formik.errors.promoDiscount[index] &&
                            typeof formik.errors.promoDiscount[index]
                              .discount === 'string') ||
                          (!formik.isValid &&
                            formik.errors.promoDiscount &&
                            Array.isArray(formik.errors.promoDiscount) &&
                            typeof formik.errors.promoDiscount[index] ===
                              'object' &&
                            formik.errors.promoDiscount[index] !== null &&
                            'discount' in formik.errors.promoDiscount[index] &&
                            typeof formik.errors.promoDiscount[index]
                              .discount === 'string' &&
                            showAllValidateErrors) ? (
                            <div className="text-danger">
                              {formik.errors.promoDiscount[index].discount}
                            </div>
                          ) : null}
                        </div>
                      </Col>

                      <Col
                        xs={2}
                        sm={2}
                        className="d-flex align-items-center mb-2 mb-xs-0"
                      >
                        {formik.values.promoDiscount.length > 1 &&
                          index > 0 && (
                            <div
                              id={`rm-promo-discount-${index}`}
                              onClick={() => arrayHelpers.remove(index)}
                              role="button"
                              tabIndex={0}
                              style={{
                                cursor: 'pointer',
                              }}
                              className="d-flex align-items-center justify-content-center"
                            >
                              <RiDeleteBin2Line size={'20px'} color="red" />
                            </div>
                          )}
                      </Col>
                    </Row>
                  )
                )}

                <Row
                  className={`${promoConditionsTitle.multiple ? '' : 'd-none'}`}
                >
                  <Col sm={12} xs={12}>
                    <div className="px-1 mb-3">
                      <Button
                        className="btn me-2"
                        id="btn-add-promo-discount"
                        type="button"
                        color="success"
                        onClick={() =>
                          formik.values.promoDiscount.length <
                            PROMOTION_DISCOUNT_LIMIT &&
                          arrayHelpers.push({
                            qty: '',
                            discount: '',
                          })
                        }
                        disabled={
                          formik.values.promoDiscount.length >=
                          PROMOTION_DISCOUNT_LIMIT
                        }
                      >
                        + {t('Btn_Add')}
                      </Button>
                      {formik.values.promoDiscount.length >=
                        PROMOTION_DISCOUNT_LIMIT && (
                        <div className="text-danger mt-2">
                          {t('ProductPage_Warn_Must_not_exceed')}{' '}
                          {PROMOTION_DISCOUNT_LIMIT}{' '}
                          {t('ProductPage_Warn_items')}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          );
        }}
      />
      {promoType === '2' && formik.values.DiscountType === '1' && (
        <div className={`mb-3 row `}>
          <Label
            htmlFor="usage_limit"
            className={`col-sm-3 col-form-label ${styles['text-pd']} px-1`}
          >
            {t('Usage limit')} <span style={{ color: 'red' }}>*</span>
          </Label>
          <Col xs={12} sm={9} lg={9} className="mb-2 mb-xs-0 px-0">
            {/* <Row
                      key={index}
                      className="align-items-top mb-3 mb-xs-0 px-0 mx-0"
                    >
                      <Col xs={5} sm={5} className="mb-2 mb-xs-0 px-0"> */}

            <Row className="align-items-top mb-0 mb-xs-0 px-0 mx-0 justify-content-space-between">
              <Col xs={5} sm={5} className="mb-0 mb-xs-0 px-0">
                <div className="input-container px-1">
                  <Cleave
                    // className={`form-control usageLimit`}
                    className={`form-control ${styles['no-px']}`}
                    name={`usage_limit`}
                    options={{
                      numeral: true,
                      numeralDecimalScale: 0,
                      numeralIntegerScale: 2,
                      numeralPositiveOnly: true,
                      // numeralThousandsGroupStyle: 'thousand',
                    }}
                    value={formik.values.usage_limit}
                    onChange={(e: any) => {
                      formik.setFieldValue(`usage_limit`, e.target.rawValue);
                    }}
                    onBlur={formik.handleBlur}
                    required
                  />
                  {(formik.touched.usage_limit && formik.errors.usage_limit) ||
                  (!formik.isValid &&
                    formik.errors.usage_limit &&
                    showAllValidateErrors) ? (
                    <div className="text-danger">
                      {formik.errors.usage_limit}
                    </div>
                  ) : null}
                </div>
              </Col>

              <Col xs={7} sm={7} className="mb-0 mb-xs-0 px-0">
                <div className="px-1">{t('usage_limit_description')}</div>
              </Col>
            </Row>
          </Col>

          {/* <Col sm={3} lg={3} className="px-0">
          <div className="input-container px-1">
            <Cleave
              // className={`form-control usageLimit`}
              className={`form-control ${styles['no-px']}`}
              name={`usage_limit`}
              options={{
                numeral: true,
                numeralDecimalScale: 0,
                numeralIntegerScale: 2,
                // numeralThousandsGroupStyle: 'thousand',
              }}
              value={formik.values.usage_limit}
              onChange={(e: any) => {
                formik.setFieldValue(`usage_limit`, e.target.rawValue);
              }}
              onBlur={formik.handleBlur}
              required
            />
            {(formik.touched.usage_limit && formik.errors.usage_limit) ||
            (!formik.isValid &&
              formik.errors.usage_limit &&
              showAllValidateErrors) ? (
              <div className="text-danger">{formik.errors.usage_limit}</div>
            ) : null}
          </div>
        </Col> */}
        </div>
      )}
    </>
  );
};
export default PromoReachPurchase;
